import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/dashboard/admin/pages/")({
  beforeLoad: () => {
    throw redirect({ to: "/dashboard/admin/content", search: { tab: "pages" } });
  },
});
